import { NormalTable } from './NormalTable';
import { Table } from './Table';
Table.Normal = NormalTable;
export default Table;
